import AttachedDocument from '@/domain/attachedDocuments/AttachedDocument';

export default class TomAttachedDocument extends AttachedDocument {}
